module.exports = __webpack_public_path__ + "static/media/roy.cd9cb74a.jpg";